// extracted by mini-css-extract-plugin
export default {"contentHeader":"ContentHeader_contentHeader__8aq4S","actions":"ContentHeader_actions__Sjebl","title":"ContentHeader_title__j6e8+"};